import type { IconData } from '@stacksjs/iconify-core'

export const imageSaturationVerticalRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.001 27.72c0 8.347 7.06 15.368 16.184 15.764c.389-3.333.815-8.905.815-17.325c0-8.864-.951-15.99-1.769-20.48c-2.363 1.88-5.767 4.832-8.77 8.352c-3.539 4.148-6.244 8.767-6.448 13.16a12 12 0 0 0-.012.53M23.421.537a4.73 4.73 0 0 1 3.439.928c2.365 1.789 6.829 5.408 10.721 9.97c3.835 4.496 7.417 10.255 7.417 16.286c0 11.048-9.528 19.782-20.998 19.782S3 38.768 3 27.721c0-6.032 3.582-11.79 7.417-16.286c3.892-4.563 8.357-8.182 10.721-9.97a4.74 4.74 0 0 1 2.282-.93\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default imageSaturationVerticalRemix
